/*
 * @Author: your name
 * @Date: 2021-06-04 18:20:13
 * @LastEditTime: 2021-07-01 14:51:57
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \qianyue\src\components\Disease\Disease.js
 */
let consultationMain = function (tokenClient, serviceAddr) {
    let TokenClient = tokenClient;
    let ServiceBaseAddress = serviceAddr;
    // 已启用分类
    //  ${docKeyWordSearch}/${doctorType}/${doctorRegionId}/${departmentId}/${levelId}/${consultationType}/${hosTitleId}/${MinPrice}/${MaxPrice}/${sortType}`;
    this.GetConsultationDoctorListData = function (parmas,success, error) {
        var url = ServiceBaseAddress + `/api/User/GetConsultationDoctorList/${parmas}`
        TokenClient.Get(url, false, null, null,
            function (data) {
                if (success) {
                    var jsonObj = JSON.parse(data);
                    success(jsonObj);
                }
            }, error);
    }

    this.GetAppletStudioGroupListStu = function (orgId,type,isRecom,success, error) {
        var url = ServiceBaseAddress + `/api/StudioGroup/GetAppletStudioGroupList/${orgId}/${type}/${isRecom}`
        TokenClient.Get(url, false, null, null,
            function (data) {
                if (success) {
                    var jsonObj = JSON.parse(data);
                    success(jsonObj);
                }
            }, error);
    }
    this.GetConsultationDoctorListStu = function (id,success, error) {
        var url = ServiceBaseAddress + `/api/StudioGroup/GetConsultationDoctorList/${id}`
        TokenClient.Get(url, false, null, null,
            function (data) {
                if (success) {
                    var jsonObj = JSON.parse(data);
                    success(jsonObj);
                }
            }, error);
    }
    this.GetAppointmentDoctorListStu = function (id,success, error) {
        var url = ServiceBaseAddress + `/api/StudioGroup/GetAppointmentDoctorList/${id}`
        TokenClient.Get(url, false, null, null,
            function (data) {
                if (success) {
                    var jsonObj = JSON.parse(data);
                    success(jsonObj);
                }
            }, error);
    }

    this.GetConsultationOrganizationListData = function (ln,la,success, error) {
        var url = ServiceBaseAddress + `/api/Organization/GetConsultationOrganizationList/${ln}/${la}`
        TokenClient.Get(url, false, null, null,
            function (data) {
                if (success) {
                    var jsonObj = JSON.parse(data);
                    success(jsonObj);
                }
            }, error);
    }
   
    this.GetChildrens = function (success, error) {
        var url = ServiceBaseAddress + `/api/Region/Childrens`
        TokenClient.Get(url, false, null, null,
            function (data) {
                if (success) {
                    var jsonObj = JSON.parse(data);
                    success(jsonObj);
                }
            }, error);
    }
    this.GetRegionChildrens = function (id,success, error) {
        var url = ServiceBaseAddress + `/api/Region/${id}/Childrens`
        TokenClient.Get(url, false, null, null,
            function (data) {
                if (success) {
                    var jsonObj = JSON.parse(data);
                    success(jsonObj);
                }
            }, error);
    }
    this.GetHospitalDept = function (success, error) {
        var url = ServiceBaseAddress + `/api/HospitalDept`
        TokenClient.Get(url, false, null, null,
            function (data) {
                if (success) {
                    var jsonObj = JSON.parse(data);
                    success(jsonObj);
                }
            }, error);
    }
    this.GetUserInfo = function (id,success, error) {
        var url = ServiceBaseAddress + `/api/User/Info/${id}`
        TokenClient.Get(url, false, null, null,
            function (data) {
                if (success) {
                    var jsonObj = JSON.parse(data);
                    success(jsonObj);
                }
            }, error);
    }
    this.GetEvaluate = function (id,type,pageIndex,pageSize,success, error) {
        var url = ServiceBaseAddress + `/api/ConsultationEvaluate/GetDoctorConsultationEvaluatePage/${id}/${type}/${pageIndex}/${pageSize}`
        TokenClient.Get(url, false, null, null,
            function (data) {
                if (success) {
                    var jsonObj = JSON.parse(data);
                    success(jsonObj);
                }
            }, error);
    }
    this.GetEvaluateTotal = function (id,success, error) {
        var url = ServiceBaseAddress + `/api/ConsultationEvaluate/GetConsultationEvaluateStatistics/${id}`
        TokenClient.Get(url, false, null, null,
            function (data) {
                if (success) {
                    var jsonObj = JSON.parse(data);
                    success(jsonObj);
                }
            }, error);
    }
    this.GetProductLevel = function (id,success, error) {
        var url = ServiceBaseAddress + `/api/OrganizationLevel/Product/${id}`
        TokenClient.Get(url, false, null, null,
            function (data) {
                if (success) {
                    var jsonObj = JSON.parse(data);
                    success(jsonObj);
                }
            }, error);
    }
    this.GetUserTitle = function (id,success, error) {
        var url = ServiceBaseAddress + `/api/UserTitle/${id}`
        TokenClient.Get(url, false, null, null,
            function (data) {
                if (success) {
                    var jsonObj = JSON.parse(data);
                    success(jsonObj);
                }
        }, error);
    }
    this.GetPatientMyself = function (id,success, error) {
        var url = ServiceBaseAddress + `/api/Patient/GetPatientListMyself/5/0/${id}/%20/%20/%20/1`
        TokenClient.Get(url, false, null, null,
            function (data) {
                if (success) {
                    var jsonObj = JSON.parse(data);
                    success(jsonObj);
                }
        }, error);
    }
    this.GetUserDistributor = function (success, error) {
        var url = ServiceBaseAddress + `/api/User/UserDistributor`
        TokenClient.Get(url, false, null, null,
            function (data) {
                if (success) {
                    var jsonObj = JSON.parse(data);
                    success(jsonObj);
                }
        }, error);
    }
    this.GetVerificationSuccessPay = function (orderId,success, error) {
        var url = ServiceBaseAddress + `/api/ConsultationOrder/VerificationSuccessPay/${orderId}`
        TokenClient.Get(url, false, null, null,
            function (data) {
                if (success) {
                    var jsonObj = JSON.parse(data);
                    success(jsonObj);
                }
        }, error);
    }
    this.GetDiagnoseList = function (Id,success, error) {
        var url = ServiceBaseAddress + `/api/PatientDiagnose/GetPatientDiagnoseList/${Id}/1/15`
        TokenClient.Get(url, false, null, null,
            function (data) {
                if (success) {
                    var jsonObj = JSON.parse(data);
                    success(jsonObj);
                }
        }, error);
    }
    this.GetDiagnoseDetail = function (Id,success, error) {
        var url = ServiceBaseAddress + `/api/PatientDiagnose/GetPatientDiagnoseDetail/${Id}`
        TokenClient.Get(url, false, null, null,
            function (data) {
                if (success) {
                    var jsonObj = JSON.parse(data);
                    success(jsonObj);
                }
        }, error);
    }

    this.GetUserOrderListData = function (type,state,pageIndex,pageSize, success, error) {
        var url = ServiceBaseAddress + `/api/ConsultationOrder/GetUserOrderList/${type}/${state}/${pageIndex}/${pageSize}`
        TokenClient.Get(url, false, null, null,
            function (data) {
                if (success) {
                    var jsonObj = JSON.parse(data);
                    success(jsonObj);
                }
        }, error);
    }

    this.GetConsultationEvaluateDetail = function (id, success, error) {
        var url = ServiceBaseAddress + `/api/ConsultationEvaluate/GetConsultationEvaluateDetail/${id}`
        TokenClient.Get(url, false, null, null,
            function (data) {
                if (success) {
                    var jsonObj = JSON.parse(data);
                    success(jsonObj);
                }
        }, error);
    }
    
    this.GetIsPayPassword = function (item,success, error) {
        if (item) {
            var url = ServiceBaseAddress + "/api/User/IsPayPassword"
            TokenClient.Post(
                url,
                true,
                { "Content-Type": "application/json" },
                item,
                function (data) {
                if (success) {
                    var jsonObj = JSON.parse(data)
                    success(jsonObj)
                }
                },
                error
            )
        }
    }
    this.GetIsSetPayPassword = function (success, error) {
        var url = ServiceBaseAddress + "/api/User/IsSetPayPassword"
        TokenClient.Post(
            url,
            true,
            { "Content-Type": "application/json" },
            null,
            function (data) {
            if (success) {
                var jsonObj = JSON.parse(data)
                success(jsonObj)
            }
            },
            error
        )
    }
    this.getAddPatient = function(item, success, error) {
        var url = ServiceBaseAddress + '/api/Patient/AddPatient'
        TokenClient.Post(url, true, { 'Content-Type': 'application/json' }, item,
            function(data) {
                if (success) {
                    var jsonObj = JSON.parse(data)
                    success(jsonObj)
                }
            },
            error
        )
    }
    this.GetDeleteOrder = function (orderId,success, error) {
        var url = ServiceBaseAddress + `/api/ConsultationOrder/DeleteOrder/${orderId}`
        TokenClient.Post(url, true, null, null,
            function (data) {
                if (success) {
                    var jsonObj = JSON.parse(data);
                    success(jsonObj);
                }
        }, error);
    }
    this.GetCancelConsultationOrder = function (orderId,success, error) {
        var url = ServiceBaseAddress + `/api/ConsultationOrder/CancelConsultationOrder/${orderId}`
        TokenClient.Post(url, true, null, null,
            function (data) {
                if (success) {
                    var jsonObj = JSON.parse(data);
                    success(jsonObj);
                }
        }, error);
    }
    this.GetUserCompleteOrder = function (orderId,state,resData,success, error) {
        var url = ServiceBaseAddress + `/api/ConsultationOrder/UserCompleteOrder/${orderId}/${state}/${resData}`
        TokenClient.Post(url, true, null, null,
            function (data) {
                if (success) {
                    var jsonObj = JSON.parse(data);
                    success(jsonObj);
                }
        }, error);
    }
  
    this.GetSubmitEvaluate = function(item, success, error) {
        var url = ServiceBaseAddress + '/api/ConsultationEvaluate/SubmitEvaluate'
        TokenClient.Post(url, true, { 'Content-Type': 'application/json' }, item,
            function(data) {
                if (success) {
                    var jsonObj = JSON.parse(data)
                    success(jsonObj)
                }
            },
            error
        )
    }
    this.GetConsultationOrderCreateOrder = function(item, success, error) {
        var url = ServiceBaseAddress + '/api/ConsultationOrder/CreateOrder'
        TokenClient.Post(url, true, { 'Content-Type': 'application/json' }, item,
            function(data) {
                if (success) {
                    var jsonObj = JSON.parse(data)
                    success(jsonObj)
                }
            },
            error
        )
    }
    this.GetOrderSubmitPay = function(item, success, error) {
        var url = ServiceBaseAddress + '/api/ConsultationOrder/SubmitPay'
        TokenClient.Post(url, true, { 'Content-Type': 'application/json' }, item,
            function(data) {
                if (success) {
                    var jsonObj = JSON.parse(data)
                    success(jsonObj)
                }
            },
            error
        )
    }
    // 提交答案
    this.getSelfDiagnosisQuestionSubmit = function(item, success, error) {
        var url = ServiceBaseAddress + '/api/SelfDiagnosisQuestion/Submit'
        TokenClient.Post(url, true, { 'Content-Type': 'application/json' }, item,
            function(data) {
                if (success) {
                    var jsonObj = JSON.parse(data)
                    success(jsonObj)
                }
            },
            error
        )
    }
}

export { consultationMain }